const cn = {
    home: {
        loading:"拼命加载中",
        contact_one:"RPA专家指导",
        contact_two:"(微信同号)",
        call_number:"178-5702-6974",
        last_update:"最后更新时间：",
    },
    topBar: {
      searchPlaceholder:"请输入搜索关键字",
        helpCenter:"帮助中心",
        detail:"无需复杂编程，轻松实现自动化流程",
    },
    word:{
      tip:"提示",
      confirm:"确定",
      cancel:"取消",
        setting:"设置",
        save:"保存",
    },
    api: {
        requestError:"请求错误"
    }
}

export default cn;
